export default __webpack_public_path__ + "static/media/gallery_05.5a5751c2.jpg";